<template>
  <el-form label-width="100px">
    <el-tabs v-model="queryParams.orderStatus" @tab-click="handleFilter('tab')">
      <el-tab-pane v-for="(item, index) in statusText" :key="index" :name="item.id" :label="`${item.text}（${item.value}）`" />
    </el-tabs>
    <el-row :gutter="20">
      <el-col :span="24">
        <el-form-item label="时间选择">
          <el-radio-group v-model="dateText" type="button" class="flex-row" @change="dateRangeChange">
            <el-radio-button v-for="(item, index) in dateSelect" :key="index" :label="item.value">{{ item.text }}</el-radio-button>
            <el-date-picker
              v-model="timeRange"
              type="daterange"
              unlink-panels
              :editable="false"
              range-separator="至"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              @change="timeRangeChange"
            />
          </el-radio-group>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :sm="24" :md="8">
        <el-form-item label="收货人">
          <el-input v-model="queryParams.consigneeInfo" placeholder="请输入收货人姓名、手机号" clearable />
        </el-form-item>
      </el-col>
      <el-col :sm="24" :md="8">
        <el-form-item label="订单号">
          <el-input v-model="queryParams.orderNumber" placeholder="请输入订单号" clearable />
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :sm="24" :md="8">
        <el-form-item label="关键词">
          <el-input v-model="queryParams.keyword" placeholder="用户昵称、手机号、分享码" clearable />
        </el-form-item>
      </el-col>
      <el-col :sm="24" :md="8">
        <el-form-item label="支付单号">
          <el-input v-model="queryParams.payNumber" placeholder="请输入支付单号" clearable />
        </el-form-item>
      </el-col>
      <el-col v-if="!showSupplier" :sm="24" :md="8">
        <el-form-item class="last-form-item" :label-width="device !== 'mobile' ? 'auto' : '100px'">
          <el-button type="primary" icon="el-icon-search" @click="handleFilter('btn')">查找</el-button>
        </el-form-item>
      </el-col>
    </el-row>

    <el-row v-if="showSupplier" :gutter="20">
      <el-col v-if="['0', '4'].includes(queryParams.orderStatus)" :sm="24" :md="8">
        <el-form-item label="配送方式" :class="{ 'last-form-item': device !== 'mobile' }">
          <el-select v-model="queryParams.deliveryMethod" placeholder="请选择配送方式" clearable>
            <el-option label="自提" :value="1" />
            <el-option label="快递" :value="2" />
          </el-select>
        </el-form-item>
      </el-col>
      <el-col v-if="queryParams.orderType === 77000" :sm="24" :md="8">
        <el-form-item label="商家名称" :class="{ 'last-form-item': device !== 'mobile' }">
          <el-input v-model="queryParams.shopName" placeholder="请输入商家名称" clearable />
        </el-form-item>
      </el-col>
      <el-col v-else :sm="24" :md="8">
        <el-form-item label="供应商" :class="{ 'last-form-item': device !== 'mobile' }">
          <el-select v-model="queryParams.supplierId" filterable clearable placeholder="请选择供应商" @change="supplierChange">
            <el-option v-for="(item, index) in suppliers" :key="index" :label="item.supplierName" :value="item.id" />
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :sm="24" :md="8">
        <el-form-item class="last-form-item" :label-width="device !== 'mobile' ? 'auto' : '100px'">
          <el-button type="primary" icon="el-icon-search" @click="handleFilter('btn')">查找</el-button>
          <el-upload
            action="#"
            style="margin: 0 10px;"
            :show-file-list="false"
            :before-upload="beforeExcelUpload"
            :http-request="handleImport"
            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          >
            <el-button type="success" icon="el-icon-download">导入</el-button>
          </el-upload>
          <el-button type="info" icon="el-icon-upload2" @click="handleExport">导出</el-button>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
import { mapGetters } from 'vuex'
import { orderExport, orderImport } from '@/api/order'

export default {
  name: 'OrderSearch',
  props: {
    params: {
      type: Object,
      default() {
        return {
          keyword: '', // 关键词（用户昵称、手机号、分享码）
          dateRange: '', // 下单日期范围
          orderNumber: '',
          orderStatus: '0',
          orderType: 75000,
          payNumber: '',
          logisticsNumber: '',
          deliveryMethod: '',
          dateStart: '',
          dateEnd: '',
          shopName: '',
          supplierId: '',
          supplierName: '',
          consigneeInfo: ''
        }
      }
    },
    suppliers: {
      type: Array,
      default() {
        return []
      }
    },
    orderCount: {
      type: Object,
      default() {
        return {
          all: 0,
          unpaid: 0,
          paid: 0,
          verified: 0,
          delivered: 0,
          completed: 0
        }
      }
    },
    statusText: {
      type: Array,
      default() {
        return [
          { id: '0', text: '全部', field: 'all', value: 0 },
          { id: '2', text: '未发货', field: 'paid', value: 0 },
          { id: '5', text: '待核销', field: 'verified', value: 0 },
          { id: '3', text: '待收货', field: 'delivered', value: 0 },
          { id: '4', text: '交易完成', field: 'completed', value: 0 }
        ]
      }
    },
    showSupplier: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      dateSelect: [
        { text: '全部', value: 'all' },
        { text: '今天', value: 'today' },
        { text: '昨天', value: 'yesterday' },
        { text: '最近7天', value: 'lastSeven' },
        { text: '最近30天', value: 'lastThirty' },
        { text: '本月', value: 'month' },
        { text: '本年', value: 'year' }
      ],
      dateText: 'all',
      timeRange: '',
      queryParams: {}
    }
  },
  computed: mapGetters(['device']),
  watch: {
    params: {
      deep: true,
      immediate: true,
      handler(newValue) {
        this.queryParams = Object.assign({}, newValue)
      }
    },
    orderCount: {
      deep: true,
      immediate: true,
      handler(newValue) {
        if (newValue) {
          this.statusText.forEach(item => {
            item.value = newValue[item.field]
          })
        }
      }
    }
  },
  methods: {
    dateRangeChange() {
      this.timeRange = ''
    },
    timeRangeChange() {
      this.dateText = this.timeRange ? '' : 'all'
    },
    supplierChange() {
      if (this.queryParams.supplierId) {
        this.suppliers.forEach(item => {
          if (item.id === this.queryParams.supplierId) this.queryParams.supplierName = item.supplierName
        })
      }
    },
    handleFilter(action) {
      this.queryParams.dateRange = this.dateText === 'all' ? '' : this.dateText
      this.queryParams.dateStart = this.timeRange ? this.timeRange[0] : ''
      this.queryParams.dateEnd = this.timeRange ? this.timeRange[1] : ''
      if (['2', '3', '5'].includes(this.queryParams.orderStatus)) this.queryParams.deliveryMethod = ''

      this.$emit('update:params', this.queryParams)
      this.$emit('filter', { action })
    },
    beforeExcelUpload(file) {
      const isXlsx = file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      if (!isXlsx) this.$message.error('导入的文件只能是 xlsx 格式')

      return isXlsx
    },
    handleImport(uploader) {
      const form = new FormData()
      form.append('file', uploader.file)
      orderImport(form).then(response => {
        if (response) {
          this.$message.success(`成功导入 ${response} 条物流信息`)
          this.$emit('import')
        }
      }).catch(() => {})
    },
    handleExport() {
      this.queryParams.dateRange = this.dateText === 'all' ? '' : this.dateText
      this.queryParams.dateStart = this.timeRange ? this.timeRange[0] : ''
      this.queryParams.dateEnd = this.timeRange ? this.timeRange[1] : ''
      this.$emit('update:params', this.queryParams)

      const params = Object.assign({}, this.queryParams)
      if (params.dateStart) params.dateStart += ' 00:00:00'
      if (params.dateEnd) params.dateEnd += ' 23:59:59'
      window.open(orderExport(params))
    }
  }
}
</script>

<style lang="scss" scoped>
  .max-width {
    max-width: 250px;
  }
  .mobile {
    .el-radio-button {
      padding-right: 10px;
      padding-bottom: 10px;
      ::v-deep {
        .el-radio-button__inner {
          border: 0;
          border-radius: 4px;
          background-color: #f7f8fa;
        }
        .el-radio-button__orig-radio:checked + .el-radio-button__inner {
          background-color: #1890ff;
        }
      }
    }
    .el-radio-group.flex-row .el-radio-button:not(:has(+ .el-radio-button)) {
      margin-right: 0;
    }
  }
</style>
